import {
  CREATE_MACHINE_ACCOUNT_FULFILLED,
  FETCH_MACHINE_ACCOUNTS_FULFILLED,
  REMOVE_MACHINE_ACCOUNT_TOKENS,
} from './actions';

import type { MachineAccount } from '@/types/safeScarf';



export interface MachineAccountsAction {
  type: string;
  payload?: MachineAccount | MachineAccount[];
}

const machineAccountsReducer = (
  state: MachineAccount[] = [],
  action: MachineAccountsAction
): MachineAccount[] => {
  switch (action.type) {
    case CREATE_MACHINE_ACCOUNT_FULFILLED:
      return [...state, action.payload as MachineAccount];
    case FETCH_MACHINE_ACCOUNTS_FULFILLED:
      return action.payload as MachineAccount[];
    case REMOVE_MACHINE_ACCOUNT_TOKENS:
      return state.map(ma => {
        const { token, ...rest } = ma;
        return rest;
      });
    default:
      return state;
  }
};

export { machineAccountsReducer };
